import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sy_icon",
  "use": "icon-sy_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-sy_icon\">\n<title>1</title>\n<path d=\"M28.8 12.151l-12.81-9.332-12.791 9.332v16.649h11.201l-0-7.93h3.198l0.001 7.93h11.201v-16.649zM15.992 6.781l9.606 6.997v11.821h-4.798l0-7.928h-9.601l-0.001 7.928h-4.798v-11.821l9.592-6.997z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol